import React        from "react";

import BomLineItem  from "./bom_line_item/BomLineItem";

const BomTable = (props) => {
  
  const {
    board_qtys,
    selected_board_qty,
    bom_line_items,
    markups,
    onShowSearchModal,
    onShowMoreOptions,
  } = props;

  if(!bom_line_items || bom_line_items.length == 0) return null

  return (
    <table className="table table-hover bom-table">
      <thead className="">
        <tr>
          <th className="status"></th>
          <th className="line-row">Item Number</th>
          <th className="part">MFG Part #</th>
          <th className="description">Description</th>
          <th className="extra-parts">Extra Parts</th>
          <th className="qty">Order Qty</th>
          <th className="price">Unit Price</th>
          <th className="tariff">Est. Tariff</th>
          <th className="action">Action</th>
          <th className="substitutes">Find Substitutes</th>
        </tr>
      </thead>
      <tbody>
        {bom_line_items.map((bli, index) => (
          <BomLineItem key={index}
            row={index + 1}
            board_qtys={board_qtys}
            selected_board_qty={selected_board_qty}
            bom_line_item={bli}
            markups={markups}
            onShowSearchModal={onShowSearchModal}
            onShowMoreOptions={onShowMoreOptions}/>
        ))}
      </tbody>
    </table>
  )
}

export default BomTable;